import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { FormInputState } from 'src_common/common/mobx-utils/Form';
import { CheckboxState } from './SwitcherOld.state';
import { Label } from 'src/domains/layouts/shared/typography/Content.style';
import { Wrapper, SwitcherWrapper, Input, Slider } from 'src/components/SwitcherNew/Switcher.style';

interface PropsType {
    state: FormInputState<boolean>;
    label: string;
    isDisabled?: boolean;
    onChange?: () => void;
}
class State {
    public constructor(
        private readonly switcherState: CheckboxState,
        private readonly props: PropsType
    ) {}
    public onChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        this.switcherState.handleChange(event);
        if (this.props.onChange !== undefined) {
            this.props.onChange();
        }
    };
}
/**
 * @deprecated - Please use this src/components/SwitcherNew/Switcher.tsx"
 */
export const Switcher = observer((props: PropsType) => {
    const { state, label, isDisabled = false } = props;
    const [switcherState] = useState(() => new CheckboxState(state));
    const [localState] = React.useState(() => new State(switcherState, props));

    return (
        <Wrapper
            isDisabled={isDisabled}
            marginBottom='24px'
        >
            <SwitcherWrapper>
                <Input
                    type='checkbox'
                    checked={switcherState.value}
                    readOnly
                    onChange={isDisabled ? undefined : localState.onChange}
                />
                <Slider />
            </SwitcherWrapper>
            <Label>{label}</Label>
        </Wrapper>
    );
});
